import React, { useState } from 'react';
import { Collapse, Tag, Spin, Col, Card, Descriptions, Typography, Button, Row } from 'antd';
import CustomerMediaProfileDetail from '@/routes/media/CustomerMediaProfileDetail';
import CustomerMedicalDetail from '@/routes/customer-medical/CustomerMedicalDetail';
import CustomerInteractionDetail from '@/routes/customers/CustomerInteractionDetail';
import FamilyRelationshipsList from '@/routes/customers/FamilyRelationshipsList';
import VoucherCustomerDetail from '@/routes/voucher/VoucherCustomerDetail';
import CustomerOrderDetail from '@/routes/customers/CustomerOrderDetail';
import CustomerInfoTab from './CustomerInfoTab';
import { EditOutlined, PlusOutlined } from '@ant-design/icons';
import CustomerServicesList from '../CustomerServicesList';
import { useDispatch } from 'react-redux';
import { useParams } from 'react-router-dom';
import { getSpecificCustomer } from '@/redux/actions/customerActions';

const { Panel } = Collapse;
const { Text } = Typography;

const InfoTab = (props) => {

    const dispatch = useDispatch();

    const { id } = useParams();

    const { customer } = props;

    const [isLoading, setIsLoading] = useState(false);

    const handleReloadData = async () => {
        try {
            setIsLoading(true);
            await dispatch(getSpecificCustomer(id));
            console.log('Reload customer data');
            setIsLoading(false);
        } catch (error) {
            console.error('Failed to reload data:', error);
        }
    };

    return (
        <div>


            <CustomerInfoTab data={customer} reloadData={props.reloadData} />
            <Collapse
                ghost
                bordered={false}
                defaultActiveKey={['1']}
                expandIconPosition="end"
                className="customer-detail-collapse mt-3"
            >
                {/* <Panel forceRender className="customer-detail-collapse-panel" header={<h4>Dịch vụ chốt</h4>} key="1">
                    <CustomerServicesList currentItem={customer} reloadData={handleReloadData} />
                </Panel> */}
                {/* <Panel forceRender className="customer-detail-collapse-panel" header={<><Tag color='#0b2b33'>1</Tag> Thông tin nhân khẩu</>} key="9">
                    <FamilyRelationshipsList currentItem={customer} />
                </Panel>
                <Panel forceRender className="customer-detail-collapse-panel" header={<><Tag color='#0b2b33'>2</Tag> Voucher</>} key="11">
                    <VoucherCustomerDetail currentCustomer={customer} />
                </Panel>
                <Panel forceRender className="customer-detail-collapse-panel" header={<><Tag color='#0b2b33'>3</Tag> Vật tư sử dụng</>} key="13">
                    <CustomerOrderDetail currentItem={customer} reloadCustomerDetail={() => props.reloadData()} />
                </Panel>
                <Panel forceRender className="customer-detail-collapse-panel" header={<><Tag color='#0b2b33'>4</Tag> Chương trình affiliate</>} key="14">
                    Chưa có dữ liệu
                </Panel>
                <Panel forceRender className="customer-detail-collapse-panel" header={<><Tag color='#0b2b33'>5</Tag> Thông tin bảo hiểm</>} key="15">
                    Chưa có dữ liệu
                </Panel> */}
            </Collapse>
        </div>
    )
}

export default InfoTab;